import React from 'react';

const EmailIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width || 24}
         height={props.height || 24} viewBox="0 0 24 24" fill="none">
        <path
            d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
            fill="currentColor"
        />
    </svg>
);

export default EmailIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/EmailIcon.jsx